import {
  LuDatabase,
  LuWebhook,
  LuGlobe,
  LuSave,
  LuMapPin,
  LuContact,
  LuListChecks,
  LuTag,
  LuHeadphones,
  LuKanban,
  LuListPlus,
  LuCreditCard,
  LuLayoutGrid,
  LuMap,
  LuFileText,
  LuPaperclip,
} from 'react-icons/lu';

export const AGENT_COLOR = '#7563D8';
export const AGENT_NODE_ID = '__agent__';
export const AGENT_TOOL_MIME = 'application/agent-tool';

export const TOOL_TYPES = {
  askLocation: {
    label: 'Pedir ubicación',
    short: 'Ubicación',
    icon: LuMapPin,
    color: '#00A884',
    category: 'Conversación',
    hint: 'Botón de ubicación de WhatsApp',
    single: true,
    suggestions: ['Cuando necesites saber dónde está el contacto', 'Cuando el contacto pida un servicio a domicilio'],
    example: [
      { from: 'user', text: 'Necesito un taxi' },
      { from: 'bot', text: 'Claro, compárteme tu ubicación para enviarte el más cercano.', action: 'Enviar ubicación' },
    ],
  },
  askContact: {
    label: 'Pedir contacto',
    short: 'Contacto',
    icon: LuContact,
    color: '#00A884',
    category: 'Conversación',
    hint: 'Botón para compartir el número',
    single: true,
    suggestions: ['Cuando necesites un número de teléfono y no lo tengas', 'Cuando el contacto pida algo para otra persona'],
    example: [
      { from: 'user', text: 'Es para mi mamá' },
      { from: 'bot', text: 'Perfecto, compárteme su contacto para avisarle.', action: 'Compartir contacto' },
    ],
  },
  options: {
    label: 'Ofrecer opciones',
    short: 'Opciones',
    icon: LuListChecks,
    color: '#00A884',
    category: 'Conversación',
    hint: 'Botones o lista que arma la IA',
    suggestions: ['Cuando el contacto deba elegir entre varias opciones', 'Cuando ofrezcas el menú de servicios'],
    example: [
      { from: 'user', text: '¿Qué servicios tienen?' },
      { from: 'bot', text: 'Elige el que necesites:', options: ['Taxi', 'Encomienda', 'Reservar'] },
    ],
  },
  transfer: {
    label: 'Transferir a un asesor',
    short: 'Transferir',
    icon: LuHeadphones,
    color: '#F56F89',
    category: 'Acciones',
    hint: 'A un área o a un asesor',
    suggestions: ['Cuando el contacto pida hablar con una persona', 'Cuando no puedas resolver lo que pide', 'Cuando el contacto esté molesto o se queje'],
    example: [
      { from: 'user', text: 'Quiero hablar con alguien' },
      { from: 'tool', text: 'Transferir a un asesor' },
      { from: 'bot', text: 'Te comunico con un asesor, en un momento te escribe.' },
    ],
  },
  saveField: {
    label: 'Guardar dato',
    short: 'Guardar dato',
    icon: LuSave,
    color: '#D89C7E',
    category: 'Acciones',
    hint: 'En un campo del contacto',
    suggestions: ['Cuando el contacto te diga un dato que debas recordar', 'Cuando el contacto te diga su nombre'],
    example: [
      { from: 'user', text: 'Me llamo Laura' },
      { from: 'tool', text: 'Guardar dato · nombre' },
      { from: 'bot', text: 'Gracias, Laura.' },
    ],
  },
  tag: {
    label: 'Etiquetar',
    short: 'Etiqueta',
    icon: LuTag,
    color: '#5BC0DE',
    category: 'Acciones',
    hint: 'Agrega etiquetas al contacto',
    suggestions: ['Cuando identifiques el motivo de la conversación', 'Cuando el contacto se queje'],
    example: [
      { from: 'user', text: 'El conductor fue muy grosero' },
      { from: 'tool', text: 'Etiquetar · Queja' },
      { from: 'bot', text: 'Lamento mucho lo ocurrido, ya lo dejé registrado.' },
    ],
  },
  stage: {
    label: 'Mover a etapa del embudo',
    short: 'Etapa',
    icon: LuKanban,
    color: '#00A884',
    category: 'Acciones',
    hint: 'Actualiza el CRM según el avance del contacto',
    suggestions: ['Cuando el contacto muestre interés real en comprar', 'Cuando el contacto confirme la compra'],
    example: [
      { from: 'user', text: 'Me interesa, ¿cuándo puedo ir a verlo?' },
      { from: 'tool', text: 'Mover a etapa · Interesado' },
      { from: 'bot', text: 'Perfecto, ¿qué día te queda mejor?' },
    ],
  },
  list: {
    label: 'Agregar a lista',
    short: 'Lista',
    icon: LuListPlus,
    color: '#00BCD4',
    category: 'Acciones',
    hint: 'Suma al contacto a una lista para campañas',
    suggestions: ['Cuando el contacto acepte recibir novedades', 'Cuando el contacto pida que le avisen de promociones'],
    example: [
      { from: 'user', text: 'Sí, avísame cuando haya promociones' },
      { from: 'tool', text: 'Agregar a lista · Novedades' },
      { from: 'bot', text: 'Listo, te avisaremos por aquí.' },
    ],
  },
  paymentLink: {
    label: 'Link de pago',
    short: 'Pago',
    icon: LuCreditCard,
    color: '#5BC0DE',
    category: 'Ventas',
    hint: 'Genera un cobro con ePayco o Wompi',
    suggestions: ['Cuando el contacto confirme que quiere pagar', 'Cuando el contacto pida cómo pagar la reserva'],
    example: [
      { from: 'user', text: 'Listo, ¿cómo pago la reserva?' },
      { from: 'tool', text: 'Link de pago · $150.000' },
      { from: 'bot', text: 'Aquí tienes el enlace para pagar: https://…' },
    ],
  },
  catalog: {
    label: 'Enviar catálogo',
    short: 'Catálogo',
    icon: LuLayoutGrid,
    color: '#448AFF',
    category: 'Ventas',
    hint: 'Muestra el catálogo de WhatsApp de la cuenta',
    single: true,
    suggestions: ['Cuando el contacto pregunte por los productos', 'Cuando el contacto quiera ver qué venden'],
    example: [
      { from: 'user', text: '¿Qué productos tienen?' },
      { from: 'bot', text: 'Mira nuestro catálogo 👇', action: 'Ver catálogo' },
    ],
  },
  locationLink: {
    label: 'Link de ubicación',
    short: 'Mapa',
    icon: LuMap,
    color: '#00A884',
    category: 'Conversación',
    hint: 'Un mapa web para marcar origen o destino',
    single: true,
    suggestions: ['Cuando necesites el destino del contacto', 'Cuando el contacto no pueda compartir su ubicación por WhatsApp'],
    example: [
      { from: 'user', text: 'Voy para el centro comercial Andino' },
      { from: 'bot', text: 'Marca tu destino en este mapa: https://…' },
      { from: 'tool', text: 'El contacto marcó el destino' },
    ],
  },
  template: {
    label: 'Enviar plantilla',
    short: 'Plantilla',
    icon: LuFileText,
    color: '#00A884',
    category: 'Conversación',
    hint: 'Una plantilla aprobada de WhatsApp, con sus parámetros',
    suggestions: ['Cuando el contacto pida la promoción del mes', 'Cuando debas enviar la confirmación oficial'],
    example: [
      { from: 'user', text: '¿Tienen alguna promoción?' },
      { from: 'tool', text: 'Enviar plantilla · promo_mes' },
      { from: 'bot', text: '[Plantilla con imagen y botón «Ver promoción»]' },
    ],
  },
  sendFile: {
    label: 'Enviar archivo',
    short: 'Archivo',
    icon: LuPaperclip,
    color: '#D89C7E',
    category: 'Conversación',
    hint: 'Un PDF, imagen o video que la IA envía cuando corresponde',
    suggestions: ['Cuando el contacto pida el brochure o la información completa', 'Cuando el contacto pida la lista de precios'],
    example: [
      { from: 'user', text: '¿Me envías el portafolio?' },
      { from: 'tool', text: 'Enviar archivo · portafolio.pdf' },
      { from: 'bot', text: 'Claro, te lo acabo de enviar 📎' },
    ],
  },
  http: {
    label: 'Consultar API',
    short: 'API',
    icon: LuGlobe,
    color: '#7ECCD8',
    category: 'Conectar con tu sistema',
    hint: 'Trae un dato y la IA lo usa para responder',
    suggestions: ['Cuando necesites consultar información en otro sistema para responder', 'Cuando el contacto pregunte por el estado de su pedido'],
    example: [
      { from: 'user', text: '¿Cuánto falta para que llegue?' },
      { from: 'tool', text: 'Consultar API · estado del servicio' },
      { from: 'bot', text: 'Tu conductor está a 4 minutos, placa ABC123.' },
    ],
  },
  webhook: {
    label: 'Avisar a mi sistema',
    short: 'Webhook',
    icon: LuWebhook,
    color: '#FC6530',
    category: 'Conectar con tu sistema',
    hint: 'Envía los datos a tu webhook (n8n, Make, Zapier, CRM)',
    suggestions: ['Cuando tengas todos los datos y debas avisar a tu sistema', 'Cuando el contacto confirme la solicitud'],
    example: [
      { from: 'user', text: 'Sí, confirmo el pedido' },
      { from: 'tool', text: 'Avisar a mi sistema · nuevo pedido' },
      { from: 'bot', text: 'Listo, tu pedido quedó registrado.' },
    ],
  },
  node: {
    label: 'Usar un nodo del bot',
    short: 'Nodo',
    icon: LuDatabase,
    color: '#7ECCD8',
    category: 'Conectar con tu sistema',
    hint: 'Reutiliza una Consulta API que ya tienes',
    suggestions: ['Cuando tengas los datos que necesita esta consulta'],
    example: [
      { from: 'user', text: 'Cancela mi servicio' },
      { from: 'tool', text: 'Usar un nodo del bot · cancelar servicio' },
      { from: 'bot', text: 'Listo, tu servicio quedó cancelado.' },
    ],
  },
};

export const TOOL_CATEGORIES = ['Conversación', 'Acciones', 'Ventas', 'Conectar con tu sistema'];

export const PARAM_TYPES = [
  { value: 'string', label: 'Texto' },
  { value: 'integer', label: 'Entero' },
  { value: 'number', label: 'Número' },
  { value: 'boolean', label: 'Sí / No' },
  { value: 'enum', label: 'Opciones' },
];

export const GUARD_TYPES = [
  { value: 'requiresValues', label: 'Requiere datos' },
  { value: 'noActive', label: 'Sin operación en curso' },
  { value: 'requiresActive', label: 'Con operación en curso' },
  { value: 'lastStatusIn', label: 'Último estado es' },
];

export const MODELS = [
  { value: 'gpt-4.1-mini', label: 'gpt-4.1-mini (recomendado)' },
  { value: 'gpt-4.1', label: 'gpt-4.1' },
  { value: 'gpt-4o-mini', label: 'gpt-4o-mini' },
];

export const toSnake = (text) =>
  String(text || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .replace(/^(\d)/, 't_$1')
    .slice(0, 60);

export const uniqueToolName = (base, tools, except = -1) => {
  const root = toSnake(base) || 'herramienta';
  const taken = new Set(tools.filter((_, i) => i !== except).map((t) => t.name));
  if (!taken.has(root)) return root;
  let n = 2;
  while (taken.has(`${root}_${n}`)) n += 1;
  return `${root}_${n}`;
};

export const createTool = (type, tools) => {
  const meta = TOOL_TYPES[type];
  const base = {
    type,
    label: meta.label,
    name: uniqueToolName(meta.label, tools),
    whenToUse: meta.suggestions?.[0] || '',
    suggested: true,
    params: [],
  };
  if (type === 'webhook') return { ...base, config: { method: 'POST', url: '', auth: { type: 'none' }, mode: 'wait' } };
  if (type === 'http') return { ...base, config: { method: 'GET', url: '', auth: { type: 'none' }, mode: 'wait' }, result: { fields: [] } };
  if (type === 'node') return { ...base, nodeId: '', result: { fields: [] } };
  if (type === 'transfer') return { ...base, config: { mode: 'automatic' } };
  if (type === 'tag') return { ...base, config: { tags: [], choose: false } };
  if (type === 'stage') return { ...base, config: { stages: [] } };
  if (type === 'list') return { ...base, config: { lists: [] } };
  if (type === 'paymentLink') return { ...base, config: { platform: '', amountMode: 'fixed', amount: '', maxAmount: '', title: '' } };
  if (type === 'catalog') return { ...base, config: { message: 'Mira nuestro catálogo 👇' } };
  if (type === 'template') return { ...base, config: { templateId: '', templateName: '', params: [], mediaType: '', mediaLink: '', mediaName: '', urlParam: '' } };
  if (type === 'sendFile') return { ...base, config: { url: '', name: '', mime: '', caption: '' } };
  if (type === 'locationLink') {
    return {
      ...base,
      config: {
        mode: 'destination',
        fields: { lat: 'destLat', lng: 'destLng', address: 'destAddress' },
        originFields: { lat: 'originLat', lng: 'originLng', address: 'originAddress' },
      },
    };
  }
  if (type === 'saveField') return { ...base, params: [{ key: 'valor', type: 'string', required: true, description: '', saveTo: { field: '' } }] };
  return base;
};

export const createDefaultAgentConfig = () => ({
  enabled: true,
  companyName: '',
  model: 'gpt-4.1-mini',
  memoryTtlMin: 120,
  instructions: {
    role: `el asistente de WhatsApp de {{marca}}`,
    personality: 'Cálido pero breve: máximo 2 líneas por mensaje.',
    style: [],
    steps: [],
    rules: [],
    info: [],
    examples: [],
  },
  context: [{ label: 'Nombre del contacto', value: '{{nombre_usuario}}', empty: 'desconocido' }],
  tracking: null,
  inputs: {},
  resetOnNewConversation: null,
  limits: { monthlyTurns: 0, message: '' },
  tools: [],
  position: { x: -420, y: 0 },
});
